// extracted by mini-css-extract-plugin
export default {"container":"_99f37462","distinction":"_390fc4d7","icon":"_f1006d6e","title":"_6f462d25","goldDiamond":"_75106b01","platinumDiamond":"_850f8e97","description":"_f5831a43"};